import { IAccessCodeService } from 'types/accessCodes';
import BaseService from './BaseService';

export default class AccessCodeService extends BaseService implements IAccessCodeService {
  fetchAccessCode = (accessCodeName: string) => {
    const config = {
      url: `/accesscode/${accessCodeName}`,
      method: 'post',
    };
    return this.doRequest(config);
  };

  processAccessCode = (accessCodeName: string) => {
    const config = {
      data: { accessCodeName },
      url: '/processaccesscode',
      method: 'post',
    };
    return this.doRequest(config);
  }
}
